import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  var sign = n < 0 ? '−' : '+';
  return sign + '₹' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}
function fmtL(v) {
  if (v == null || isNaN(v)) return '--';
  var a = Math.abs(v);
  var s = a >= 1e7 ? (v / 1e7).toFixed(2) + 'Cr' : a >= 1e5 ? (v / 1e5).toFixed(1) + 'L' : String(Math.round(v));
  return (v > 0 ? '+' : '') + s;
}

var OIRideRM = function () {
  var [state, setState] = useState(null);
  var [err, setErr] = useState('');

  var fetchState = useCallback(function () {
    fetch(API + '/oirider/state').then(function (r) { return r.json(); }).then(function (d) {
      if (d && !d.error) { setState(d); setErr(''); } else setErr((d && d.error) || 'unavailable');
    }).catch(function () { setErr('backend unreachable'); });
  }, []);

  useEffect(function () {
    fetchState();
    var id = setInterval(fetchState, 1000);
    function wake() { if (!document.hidden) fetchState(); }
    document.addEventListener('visibilitychange', wake);
    return function () { clearInterval(id); document.removeEventListener('visibilitychange', wake); };
  }, [fetchState]);

  var sig = (state && state.signal) || {};
  var pend = (state && state.pending) || {};
  var pos = state && state.position;
  var st = (state && state.stats) || {};
  var trades = (state && state.trades) || [];
  var cfg = (state && state.config) || {};
  var vCol = sig.verdict === 'LONG' ? '#22c55e' : sig.verdict === 'SHORT' ? '#ef4444' : '#8b98a9';
  var mx = Math.max(Math.abs(sig.dpe || 0), Math.abs(sig.dce || 0), 1);
  var card = { background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 12, padding: '12px 14px', marginBottom: 10 };

  function bar(v, col) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{ flex: 1, height: 10, background: '#0d1524', borderRadius: 4, overflow: 'hidden' }}>
          <div style={{ width: (Math.abs(v) / mx * 100) + '%', height: '100%', background: col, opacity: 0.85 }} />
        </div>
        <span style={{ fontSize: 11, fontWeight: 800, color: col, minWidth: 58, textAlign: 'right' }}>{fmtL(v)}</span>
      </div>
    );
  }

  return (
    <div style={{ padding: '14px 14px 90px', color: '#e5e7eb', fontFamily: 'inherit', overflowY: 'auto', height: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 19, fontWeight: 800 }}>🌊 OI Ride-R</span>
        <span style={{ fontSize: 8, fontWeight: 800, letterSpacing: 1, color: '#38bdf8', background: 'rgba(56,189,248,0.1)', border: '1px solid rgba(56,189,248,0.4)', borderRadius: 6, padding: '2px 7px' }}>SIGNALS ONLY</span>
        <span style={{ fontSize: 8, fontWeight: 800, letterSpacing: 1, color: '#a78bfa', background: 'rgba(167,139,250,0.1)', border: '1px solid rgba(167,139,250,0.45)', borderRadius: 6, padding: '2px 6px' }}>DEBIT</span>
        {state && state.is_expiry_day ? <span style={{ fontSize: 8, fontWeight: 800, color: '#fbbf24', background: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.45)', borderRadius: 6, padding: '2px 7px' }}>EXPIRY ±1</span> : null}
      </div>
      <div style={{ fontSize: 9, color: '#6b7a8d', marginBottom: 12 }}>
        ΔOI rider · ATM±{cfg.strikes_band || 20} · flip on reverse ≥{cfg.threshold_pct || 10}% · exit {cfg.exit_time || '15:00'}
      </div>

      {err ? <div style={{ ...card, borderColor: 'rgba(251,191,36,0.45)', color: '#fbbf24', fontSize: 11 }}>OI Ride: {err}</div> : null}

      {/* signal */}
      <div style={card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
          <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#556677' }}>SIGNAL</span>
          <span style={{ fontSize: 9, color: '#6b7a8d' }}>{sig.time || '--'}</span>
        </div>
        <div style={{ display: 'grid', gap: 6 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ fontSize: 9, color: '#22c55e', fontWeight: 800, width: 26 }}>ΔPE</span><div style={{ flex: 1 }}>{bar(sig.dpe || 0, '#22c55e')}</div></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ fontSize: 9, color: '#ef4444', fontWeight: 800, width: 26 }}>ΔCE</span><div style={{ flex: 1 }}>{bar(sig.dce || 0, '#ef4444')}</div></div>
        </div>
        <div style={{ marginTop: 8, display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 20, fontWeight: 800, color: vCol }}>{sig.verdict || '--'}</span>
          <span style={{ fontSize: 11, color: '#c4cfd8' }}>{sig.pct != null ? (sig.pct > 0 ? '+' : '') + sig.pct + '%' : ''}</span>
          {pend.dir ? <span style={{ fontSize: 9, fontWeight: 800, color: '#fbbf24' }}>confirming {pend.dir} {pend.count}/{pend.need}</span> : null}
        </div>
      </div>

      {/* position */}
      <div style={card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
          <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#556677' }}>POSITION</span>
          {pos ? <span style={{ fontSize: 12, fontWeight: 800, color: (pos.unrealized || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(pos.unrealized)}</span> : null}
        </div>
        {pos ? (
          <div style={{ fontSize: 11, lineHeight: 1.8 }}>
            <div style={{ fontWeight: 800, color: pos.dir === 'LONG' ? '#22c55e' : '#ef4444' }}>{pos.dir} · {pos.opened} · credit {pos.credit}</div>
            {(pos.legs || []).map(function (l, i) {
              return <div key={i} style={{ color: '#8b98a9', fontSize: 10.5 }}>
                {l.kind === 'sell' ? 'SELL' : 'HEDGE'} {l.strike} {l.side} @ {l.entry} → {l.ltp}
                <span style={{ float: 'right', fontWeight: 800, color: (l.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(l.pnl)}</span>
              </div>;
            })}
          </div>
        ) : (
          <div style={{ fontSize: 10, color: '#6b7a8d', textAlign: 'center', padding: '8px 0' }}>Flat · waiting for a confirmed signal</div>
        )}
      </div>

      {/* stats */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
        {[['DAY', st.day_pnl], ['REAL', st.realized], ['UNRL', st.unrealized]].map(function (b, i) {
          return (
            <div key={i} style={{ flex: 1, background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '7px 6px', textAlign: 'center' }}>
              <div style={{ fontSize: 8, fontWeight: 800, color: '#556677' }}>{b[0]}</div>
              <div style={{ fontSize: 13, fontWeight: 800, color: (b[1] || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(b[1])}</div>
            </div>
          );
        })}
        <div style={{ flex: 0.7, background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '7px 6px', textAlign: 'center' }}>
          <div style={{ fontSize: 8, fontWeight: 800, color: '#556677' }}>TRADES</div>
          <div style={{ fontSize: 13, fontWeight: 800 }}>{st.trades != null ? st.trades : '-'}</div>
        </div>
      </div>

      {/* trades */}
      <div style={card}>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 8 }}>TRADES TODAY</div>
        {trades.length ? trades.map(function (t, i) {
          return (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 6, padding: '6px 0', borderBottom: '1px solid #131a2a', fontSize: 10.5 }}>
              <span style={{ fontWeight: 800, color: t.dir === 'LONG' ? '#22c55e' : '#ef4444' }}>{t.dir}</span>
              <span style={{ color: '#8b98a9' }}>{t.opened}→{t.closed}</span>
              <span style={{ fontSize: 8.5, fontWeight: 800, color: '#8b98a9', alignSelf: 'center' }}>{t.reason}</span>
              <span style={{ fontWeight: 800, color: (t.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(t.pnl)}</span>
            </div>
          );
        }) : <div style={{ fontSize: 10, color: '#6b7a8d', textAlign: 'center', padding: '8px 0' }}>None yet.</div>}
      </div>
    </div>
  );
};

export default OIRideRM;
